<template>
  <div class="phone-verify-mark" v-if="visible">
    <div class="phone-verify-bg">
      <div class="phone-verify-container" role="dialog" aria-modal="true" :aria-label="$t('phoneVerify.title')">
        <h4 class="phone-verify-title">{{ $t('phoneVerify.title') }}</h4>
        <p class="phone-verify-desc">{{ $t('phoneVerify.desc') }}</p>
        <PhoneVerifyForm
          :masked-mobile="maskedMobile"
          :has-mobile="hasMobile"
          @success="onVerified"
        />
        <div class="phone-verify-actions">
          <a href="javascript:void(0);" @click="goNotice">{{ $t('phoneVerify.toNotice') }}</a>
          <a href="javascript:void(0);" @click="logout">{{ $t('phoneVerify.logout') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import bus from 'vue3-eventbus';
import PhoneVerifyForm from '@/components/common/PhoneVerifyForm.vue';
import { clearAuthSession } from '@/utils/authSession';
import {
  hidePhoneVerifyOverlay,
  NOTICE_LIST_PATH,
  maskMobile,
  isBoundMobile,
} from '@/utils/phoneVerify';

const store = useStore();
const router = useRouter();
const visible = ref(false);

const maskedMobile = computed(() => {
  return store.state.user.phoneVerifyMaskedMobile ||
    maskMobile(store.state.user.personProfile.mobile || store.state.user.userInfo.mobile || '');
});
const hasMobile = computed(() => {
  return !!store.state.user.phoneVerifyHasMobile ||
    isBoundMobile(store.state.user.personProfile.mobile || store.state.user.userInfo.mobile);
});

const onShow = (show) => {
  visible.value = !!show;
  if (show && !store.state.user.phoneVerifyMaskedMobile) {
    store.dispatch('user/getPersonInfo', {}).catch(() => {});
  }
};

watch(visible, (show) => {
  document.body.style.overflow = show ? 'hidden' : '';
});

onMounted(() => {
  bus.on('showPhoneVerifyOverlay', onShow);
});

onBeforeUnmount(() => {
  bus.off('showPhoneVerifyOverlay', onShow);
  document.body.style.overflow = '';
});

const onVerified = () => {
  visible.value = false;
};

const goNotice = () => {
  hidePhoneVerifyOverlay();
  router.push(NOTICE_LIST_PATH);
};

const logout = () => {
  hidePhoneVerifyOverlay();
  clearAuthSession();
  location.reload();
};
</script>

<style scoped>
.phone-verify-mark {
  position: fixed;
  z-index: 10000;
  inset: 0;
}
.phone-verify-bg {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.55);
}
.phone-verify-container {
  width: 92%;
  max-width: 460px;
  background: #fff;
  padding: 36px 32px 28px;
  box-sizing: border-box;
}
.phone-verify-title {
  margin: 0;
  font-size: 22px;
  line-height: 1.4;
}
.phone-verify-desc {
  margin: 12px 0 24px;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}
.phone-verify-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.phone-verify-actions a {
  color: rgb(64, 158, 255);
  text-decoration: none;
  font-size: 14px;
}
</style>
